import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CountDownComponent } from '../../components/count-down/count-down.component';

@Component({
    selector: 'app-bets-status',
    standalone: true,
    imports: [CommonModule, CountDownComponent],
    templateUrl: './bets-status.component.html',
    styleUrl: './bets-status.component.scss'
})
export class BetsStatusComponent {
    private static readonly secondsToMsFactor = 1000;
    private static readonly updateIntervalMs = 200;
    private static readonly startingHue = 160;
    private static readonly maxAmount = 315;
    private static readonly defaultHurryUpPoint = 0.33;

    @Input()
    initialTimeInSeconds!: number;

    @Input()
    animate = true;

    @Input()
    hurryUpPoint = BetsStatusComponent.defaultHurryUpPoint;

    protected hurryUp = false;

    onCountDownProgress(progress: number): void {
        if (progress < this.hurryUpPoint) {
            this.hurryUp = true;
        }
    }
}
